import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49;

import React from 'react';
import styled, { keyframes } from '@xstyled/styled-components';
import Image from 'next/image';
import { AudioOutlined, LoadingOutlined, ReloadOutlined, SendOutlined, StopOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import { AudioPlayerV2, getColor, getSize, PrimaryButton, SecondaryButton } from '@lib/common';
import { TimeUnit } from '@module/form';
import { resolveSpeakingLabel } from '../speaking-labels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  position: relative;\n  transition:\n    background-color 0.3s ease,\n    border-color 0.3s ease;\n"])), getColor('fillBgSub'), getColor('shapeBorder'), getSize('radiusSm'), getSize('padding24'));
var StyledRecordedContainer = styled(StyledContainer)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  align-items: flex-start;\n  justify-content: flex-start;\n  min-height: auto;\n"])), getColor('fillHighlight4'), getColor('successHighlighted'));
var StyledDeniedContainer = styled(StyledContainer)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n"])), getColor('errorBgSubtle'), getColor('errorBorderSubtle'));
var StyledRecordingContainer = styled(StyledContainer)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n"])), getColor('errorBgSubtle'), getColor('errorBorderSubtle'));
var MicButton = styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 72px;\n  height: 72px;\n  border: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: ", ";\n  opacity: ", ";\n  box-shadow: ", ";\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease,\n    filter 0.2s ease;\n\n  &:hover:not(:disabled) {\n    transform: scale(1.05);\n    box-shadow: 0 6px 18px ", ";\n    filter: brightness(0.96);\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.98);\n  }\n"])), function (_ref) {
  var $disabled = _ref.$disabled;
  return $disabled ? "1px solid ".concat(getColor('shapeBorder')) : 'none';
}, function (_ref2) {
  var $disabled = _ref2.$disabled;
  return $disabled ? getColor('shapeBorder') : getColor('fillIntActive');
}, function (_ref3) {
  var $disabled = _ref3.$disabled;
  return $disabled ? getColor('textIntDisabled') : getColor('fillBgWhite');
}, function (_ref4) {
  var $disabled = _ref4.$disabled;
  return $disabled ? 'not-allowed' : 'pointer';
}, function (_ref5) {
  var $disabled = _ref5.$disabled;
  return $disabled ? 0.7 : 1;
}, function (_ref6) {
  var $disabled = _ref6.$disabled;
  return $disabled ? 'none' : "0 4px 14px ".concat(getColor('fillIntHighlighted'));
}, getColor('fillIntHighlighted'));
var StyledAudioIcon = styled(AudioOutlined)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 28px;\n  color: ", ";\n"])), function (_ref7) {
  var $disabled = _ref7.$disabled;
  return $disabled ? getColor('textIntDisabled') : getColor('fillBgWhite');
});
var StyledHintText = styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin: ", " 0 ", ";\n  font-size: ", ";\n  color: ", ";\n  text-align: center;\n"])), getSize('padding16'), getSize('padding4'), getSize('typo14'), getColor('contentBody'));
var StyledSubHintText = styled.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 13px;\n  color: ", ";\n  text-align: center;\n"])), getColor('textIntSub'));
var StyledMinimumDurationHint = styled(StyledSubHintText)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), getSize('padding8'));
var StatusHeader = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: ", ";\n"])), getSize('padding12'));
var StatusTitle = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  font-size: 16px;\n  font-weight: 700;\n  color: ", ";\n"])), getSize('padding8'), getColor('contentHeading'));
var PrimaryStatusTitle = styled(StatusTitle)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), getColor('fillIntActive'));
var ErrorStatusTitle = styled(StatusTitle)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), getColor('errorActive'));
var Dot = styled.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n"])));
var PrimaryDot = styled(Dot)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), getColor('fillIntActive'));
var SuccessDot = styled(Dot)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), getColor('successActive'));
var ErrorDot = styled(Dot)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), getColor('errorActive'));
var Timer = styled.span(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-size: 24px;\n  font-weight: 800;\n"])));
var PrimaryTimer = styled(Timer)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), getColor('fillIntActive'));
var ErrorTimer = styled(Timer)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), getColor('errorActive'));
var ProgressTrack = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 8px;\n  overflow: hidden;\n  border-radius: 4px;\n  margin-bottom: ", ";\n"])), getSize('padding20'));
var PreparationProgressTrack = styled(ProgressTrack)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), getColor('fillIntHighlighted'));
var RecordingProgressTrack = styled(ProgressTrack)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), getColor('shapeBorder'));
var ProgressFill = styled.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: 100%;\n  transition: width 0.3s linear;\n"])), function (_ref8) {
  var $percent = _ref8.$percent;
  return "".concat($percent, "%");
});
var PreparationProgressFill = styled(ProgressFill)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), getColor('fillIntActive'));
var RecordingProgressFill = styled(ProgressFill)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), getColor('errorActive'));
var waveBarAnimation = keyframes(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  0%, 100% {\n    transform: scaleY(0.25);\n    opacity: 0.65;\n  }\n  50% {\n    transform: scaleY(1);\n    opacity: 1;\n  }\n"])));
var Waveform = styled.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  height: 40px;\n  margin-bottom: ", ";\n"])), getSize('padding16'));
var WaveBarBase = styled.span(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  width: 3px;\n  border-radius: 999px;\n  background-color: ", ";\n  transform-origin: center;\n"])), getColor('errorActive'));
var WaveBar = styled(WaveBarBase)(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  height: ", "px;\n  animation: ", " ", "s ease-in-out infinite;\n  animation-delay: ", "s;\n"])), function (_ref9) {
  var $height = _ref9.$height;
  return $height;
}, waveBarAnimation, function (_ref10) {
  var $duration = _ref10.$duration;
  return $duration;
}, function (_ref11) {
  var $delay = _ref11.$delay;
  return $delay;
});
var ActionButtonWrapper = styled.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: ", ";\n  width: 100%;\n  margin-top: ", ";\n"])), getSize('padding12'), getSize('padding16'));
var StyledSkipButton = styled(SecondaryButton)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  font-weight: 600;\n"])), getSize('padding8'));
var StyledRecordingStopButton = styled(Button)(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n  padding: 0 ", ";\n  border-radius: ", ";\n  font-weight: 600;\n"])), getSize('padding8'), getSize('padding24'), getSize('radiusS'));
var StyledSecondaryActionButton = styled(SecondaryButton)(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  font-weight: 600;\n"])));
var StyledPrimaryActionButton = styled(PrimaryButton)(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  font-weight: 600;\n"])));
var ShieldIconBadge = styled.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  width: 64px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n"])), getSize('padding16'), getColor('errorBgActive'), getColor('errorActive'));
var LockedMicCircle = styled.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  width: 72px;\n  height: 72px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: ", ";\n  border: 2px dashed ", ";\n  border-radius: 50%;\n  background-color: ", ";\n"])), getSize('padding16'), getColor('shapeBorder'), getColor('fillBgWhite'));
var LockedMicIcon = styled(AudioOutlined)(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  font-size: 28px;\n  color: ", ";\n"])), getColor('textIntDisabled'));
var LockIconBadge = styled.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  display: flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ", ";\n  border-radius: 50%;\n  background-color: ", ";\n"])), getColor('shapeBorder'), getColor('fillBgWhite'));
var PermissionTitle = styled.h4(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  margin: 0 0 ", ";\n  font-size: 16px;\n  font-weight: 700;\n  color: ", ";\n  text-align: center;\n"])), getSize('padding8'), getColor('contentHeading'));
var ErrorPermissionTitle = styled(PermissionTitle)(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), getColor('errorActive'));
var PermissionDescription = styled.p(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  max-width: 480px;\n  margin: 0 0 ", ";\n  font-size: 14px;\n  line-height: 1.5;\n  color: ", ";\n  text-align: center;\n"])), getSize('padding16'), getColor('contentBody'));
var OutOfAttemptsTitle = styled(PermissionTitle)(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), getSize('typo18'));
var OutOfAttemptsDescription = styled(PermissionDescription)(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"])));
var StyledRetryButton = styled(Button)(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  font-size: ", ";\n  font-weight: 600;\n"])), getSize('radiusS'), getSize('typo15'));
var StyledNativeAudio = styled.audio(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AudioPlayerWrapper = styled.div(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StatusTitleWrapper = styled.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding4'));
var SubDurationText = styled.span(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 500;\n  color: ", ";\n"])), getSize('typo14'), getColor('contentBody'));
var WAVE_BAR_PATTERN = [12, 22, 28, 16, 34, 20, 14, 26, 32, 18, 24, 30, 16, 28, 22, 34, 14, 26, 18, 22, 16, 24];

var renderPreparationAndSpeakingHint = function renderPreparationAndSpeakingHint(template, preparation, speaking) {
  return template.split(/({{prep}}|{{speaking}})/g).map(function (part, index) {
    if (part === '{{prep}}') return /*#__PURE__*/_jsx("strong", {
      children: preparation
    }, index);
    if (part === '{{speaking}}') return /*#__PURE__*/_jsx("strong", {
      children: speaking
    }, index);
    return /*#__PURE__*/_jsx(React.Fragment, {
      children: part
    }, index);
  });
};

export var SpeakingRecorderInitArea = function SpeakingRecorderInitArea(_ref12) {
  var label = _ref12.label,
      disabled = _ref12.disabled,
      preparationSeconds = _ref12.preparationSeconds,
      speakingSeconds = _ref12.speakingSeconds,
      onStart = _ref12.onStart;
  var resolvedLabel = resolveSpeakingLabel(label);
  var preparation = TimeUnit.formatTimer(preparationSeconds);
  var speaking = TimeUnit.formatTimer(speakingSeconds);
  return /*#__PURE__*/_jsxs(StyledContainer, {
    children: [/*#__PURE__*/_jsx(MicButton, {
      $disabled: disabled,
      disabled: disabled,
      onClick: onStart,
      title: resolvedLabel.speaking,
      children: /*#__PURE__*/_jsx(StyledAudioIcon, {
        $disabled: disabled
      })
    }), /*#__PURE__*/_jsxs(StyledHintText, {
      children: [resolvedLabel.pressToStart, ' ', renderPreparationAndSpeakingHint(resolvedLabel.prepAndAnswerHint, preparation, speaking)]
    }), /*#__PURE__*/_jsx(StyledSubHintText, {
      children: resolvedLabel.micPermissionHint
    })]
  });
};
export var SpeakingPermissionArea = function SpeakingPermissionArea(_ref13) {
  var label = _ref13.label,
      disabled = _ref13.disabled,
      state = _ref13.state,
      onRetry = _ref13.onRetry;
  var resolvedLabel = resolveSpeakingLabel(label);

  if (state === 'requesting' || state === 'reserving') {
    var isReservingAttempt = state === 'reserving';
    return /*#__PURE__*/_jsxs(StyledContainer, {
      children: [/*#__PURE__*/_jsx(Spin, {
        indicator: /*#__PURE__*/_jsx(LoadingOutlined, {
          spin: true
        })
      }), /*#__PURE__*/_jsx(StyledHintText, {
        children: isReservingAttempt ? resolvedLabel.reservingAttempt : resolvedLabel.requestingMicPermission
      }), /*#__PURE__*/_jsx(StyledSubHintText, {
        children: isReservingAttempt ? resolvedLabel.reservingAttemptHint : resolvedLabel.allowMicDialogHint
      })]
    });
  }

  var isUnsupported = state === 'unsupported';
  return /*#__PURE__*/_jsxs(StyledDeniedContainer, {
    children: [/*#__PURE__*/_jsx(ShieldIconBadge, {
      children: isUnsupported ? /*#__PURE__*/_jsx(AudioOutlined, {}) : /*#__PURE__*/_jsx(Image, {
        src: "/icons/shield-alert.svg",
        width: 32,
        height: 32,
        alt: ""
      })
    }), /*#__PURE__*/_jsx(ErrorPermissionTitle, {
      children: isUnsupported ? resolvedLabel.noAudioOnDeviceTitle : resolvedLabel.noMicPermission
    }), /*#__PURE__*/_jsx(PermissionDescription, {
      children: isUnsupported ? resolvedLabel.noAudioOnDeviceDescription : resolvedLabel.deniedMicPermissionHint
    }), onRetry && /*#__PURE__*/_jsx(StyledRetryButton, {
      type: "default",
      size: "large",
      disabled: disabled,
      onClick: onRetry,
      children: resolvedLabel.tryAgain
    })]
  });
};
export var SpeakingOutOfAttemptsArea = function SpeakingOutOfAttemptsArea(_ref14) {
  var label = _ref14.label;
  var resolvedLabel = resolveSpeakingLabel(label);
  return /*#__PURE__*/_jsxs(StyledContainer, {
    children: [/*#__PURE__*/_jsxs(LockedMicCircle, {
      children: [/*#__PURE__*/_jsx(LockedMicIcon, {}), /*#__PURE__*/_jsx(LockIconBadge, {
        children: /*#__PURE__*/_jsx(Image, {
          src: "/icons/lock.svg",
          width: 14,
          height: 14,
          alt: ""
        })
      })]
    }), /*#__PURE__*/_jsx(OutOfAttemptsTitle, {
      children: resolvedLabel.outOfAttemptsTitle
    }), /*#__PURE__*/_jsx(OutOfAttemptsDescription, {
      children: resolvedLabel.outOfAttemptsSubtitle
    })]
  });
};
export var SpeakingPreparationArea = function SpeakingPreparationArea(_ref15) {
  var label = _ref15.label,
      disabled = _ref15.disabled,
      timeLeft = _ref15.timeLeft,
      totalSeconds = _ref15.totalSeconds,
      onSkip = _ref15.onSkip;
  var resolvedLabel = resolveSpeakingLabel(label);
  var percent = totalSeconds > 0 ? Math.max(0, Math.min(100, (totalSeconds - timeLeft) / totalSeconds * 100)) : 100;
  return /*#__PURE__*/_jsxs(StyledContainer, {
    children: [/*#__PURE__*/_jsxs(StatusHeader, {
      children: [/*#__PURE__*/_jsxs(PrimaryStatusTitle, {
        children: [/*#__PURE__*/_jsx(PrimaryDot, {}), /*#__PURE__*/_jsx("span", {
          children: resolvedLabel.preparing
        })]
      }), /*#__PURE__*/_jsx(PrimaryTimer, {
        children: TimeUnit.formatTimer(timeLeft)
      })]
    }), /*#__PURE__*/_jsx(PreparationProgressTrack, {
      children: /*#__PURE__*/_jsx(PreparationProgressFill, {
        $percent: percent
      })
    }), /*#__PURE__*/_jsx(StyledSkipButton, {
      disabled: disabled,
      onClick: onSkip,
      children: resolvedLabel.skipPreparation
    })]
  });
};
export var SpeakingRecordingArea = function SpeakingRecordingArea(_ref16) {
  var label = _ref16.label,
      disabled = _ref16.disabled,
      timeLeft = _ref16.timeLeft,
      totalSeconds = _ref16.totalSeconds,
      recordedDuration = _ref16.recordedDuration,
      minimumDuration = _ref16.minimumDuration,
      onStop = _ref16.onStop;
  var resolvedLabel = resolveSpeakingLabel(label);
  var percent = totalSeconds > 0 ? Math.max(0, Math.min(100, (totalSeconds - timeLeft) / totalSeconds * 100)) : 100;
  var canStop = minimumDuration === 0 || recordedDuration >= minimumDuration;
  var hint = resolvedLabel.canStopAfter.replace('{{sec}}', String(Math.max(0, minimumDuration - recordedDuration))).replace('{{min}}', String(minimumDuration));
  return /*#__PURE__*/_jsxs(StyledRecordingContainer, {
    children: [/*#__PURE__*/_jsxs(StatusHeader, {
      children: [/*#__PURE__*/_jsxs(ErrorStatusTitle, {
        children: [/*#__PURE__*/_jsx(ErrorDot, {}), /*#__PURE__*/_jsx("span", {
          children: resolvedLabel.recording
        })]
      }), /*#__PURE__*/_jsx(ErrorTimer, {
        children: TimeUnit.formatTimer(timeLeft)
      })]
    }), /*#__PURE__*/_jsx(RecordingProgressTrack, {
      children: /*#__PURE__*/_jsx(RecordingProgressFill, {
        $percent: percent
      })
    }), /*#__PURE__*/_jsx(Waveform, {
      children: WAVE_BAR_PATTERN.map(function (height, index) {
        return /*#__PURE__*/_jsx(WaveBar, {
          $height: height,
          $delay: index * 0.07 % 0.7,
          $duration: 0.7 + index % 4 * 0.15
        }, index);
      })
    }), /*#__PURE__*/_jsx(StyledRecordingStopButton, {
      type: "primary",
      danger: true,
      size: "large",
      icon: /*#__PURE__*/_jsx(StopOutlined, {}),
      disabled: !canStop || disabled,
      onClick: onStop,
      children: resolvedLabel.stopRecording
    }), minimumDuration > 0 && !canStop && /*#__PURE__*/_jsx(StyledMinimumDurationHint, {
      children: hint
    })]
  });
};

var RecordingAudio = function RecordingAudio(_ref17) {
  var audioUrl = _ref17.audioUrl,
      duration = _ref17.duration,
      audioId = _ref17.audioId,
      useNativeAudio = _ref17.useNativeAudio;
  return /*#__PURE__*/_jsx(AudioPlayerWrapper, {
    children: useNativeAudio ? /*#__PURE__*/_jsx(StyledNativeAudio, {
      controls: true,
      src: audioUrl
    }) : /*#__PURE__*/_jsx(AudioPlayerV2, {
      source: audioUrl,
      audioId: audioId,
      duration: duration,
      isCanSeek: true
    })
  });
};

export var SpeakingRecordedArea = function SpeakingRecordedArea(_ref18) {
  var label = _ref18.label,
      disabled = _ref18.disabled,
      audioUrl = _ref18.audioUrl,
      duration = _ref18.duration,
      onReRecord = _ref18.onReRecord,
      onSubmit = _ref18.onSubmit,
      _ref18$canReRecord = _ref18.canReRecord,
      canReRecord = _ref18$canReRecord === void 0 ? true : _ref18$canReRecord,
      isSubmitting = _ref18.isSubmitting,
      audioId = _ref18.audioId,
      useNativeAudio = _ref18.useNativeAudio;
  var resolvedLabel = resolveSpeakingLabel(label);
  return /*#__PURE__*/_jsxs(StyledRecordedContainer, {
    children: [/*#__PURE__*/_jsx(StatusHeader, {
      children: /*#__PURE__*/_jsxs(StatusTitleWrapper, {
        children: [/*#__PURE__*/_jsxs(StatusTitle, {
          children: [/*#__PURE__*/_jsx(SuccessDot, {}), /*#__PURE__*/_jsx("span", {
            children: resolvedLabel.recordReady
          })]
        }), /*#__PURE__*/_jsxs(SubDurationText, {
          children: [resolvedLabel.duration, ": ", TimeUnit.formatTimer(duration)]
        })]
      })
    }), /*#__PURE__*/_jsx(RecordingAudio, {
      audioUrl: audioUrl,
      duration: duration,
      audioId: audioId,
      useNativeAudio: useNativeAudio
    }), (onReRecord || onSubmit) && /*#__PURE__*/_jsxs(ActionButtonWrapper, {
      children: [canReRecord && onReRecord && /*#__PURE__*/_jsxs(StyledSecondaryActionButton, {
        disabled: disabled || isSubmitting,
        onClick: onReRecord,
        children: [/*#__PURE__*/_jsx(ReloadOutlined, {}), " ", resolvedLabel.reRecord]
      }), onSubmit && /*#__PURE__*/_jsxs(StyledPrimaryActionButton, {
        disabled: disabled,
        loading: isSubmitting,
        onClick: onSubmit,
        children: [/*#__PURE__*/_jsx(SendOutlined, {}), " ", resolvedLabel.submitAnswer]
      })]
    })]
  });
};
export var SpeakingSubmittedRecordingArea = function SpeakingSubmittedRecordingArea(_ref19) {
  var label = _ref19.label,
      audioUrl = _ref19.audioUrl,
      duration = _ref19.duration,
      audioId = _ref19.audioId,
      useNativeAudio = _ref19.useNativeAudio;
  var resolvedLabel = resolveSpeakingLabel(label);
  return /*#__PURE__*/_jsxs(StyledRecordedContainer, {
    children: [/*#__PURE__*/_jsx(StatusHeader, {
      children: /*#__PURE__*/_jsxs(StatusTitleWrapper, {
        children: [/*#__PURE__*/_jsxs(StatusTitle, {
          children: [/*#__PURE__*/_jsx(SuccessDot, {}), /*#__PURE__*/_jsx("span", {
            children: resolvedLabel.submittedAnswerTitle
          })]
        }), /*#__PURE__*/_jsxs(SubDurationText, {
          children: [resolvedLabel.duration, ": ", TimeUnit.formatTimer(duration)]
        })]
      })
    }), /*#__PURE__*/_jsx(RecordingAudio, {
      audioUrl: audioUrl,
      duration: duration,
      audioId: audioId,
      useNativeAudio: useNativeAudio
    })]
  });
};